module.exports = __webpack_public_path__ + "static/full-stack-project-blockchain-1-335c813ce274c63d9ee591537b8fa2d4.png";